import { render, staticRenderFns } from "./UserView.vue?vue&type=template&id=7fe61a79&"
import script from "./UserView.vue?vue&type=script&lang=js&"
export * from "./UserView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe61a79')) {
      api.createRecord('7fe61a79', component.options)
    } else {
      api.reload('7fe61a79', component.options)
    }
    module.hot.accept("./UserView.vue?vue&type=template&id=7fe61a79&", function () {
      api.rerender('7fe61a79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/users/views/UserView.vue"
export default component.exports